<template>
  <div id="CardHoddy">
    <div class="build" :class="'no404'">
      <div>
        网页不见了...
      </div>
    </div>
    <shop-footer></shop-footer>
  </div>
</template>
<script>
import ShopFooter from './footer'
export default {
  name: 'error',
  components: {
    ShopFooter
  },
  data() {
    return {}
  },
  mounted() {},
  created() {},
  methods: {

  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/error.vue